import React, { Component } from "react";
import Alert from "react-s-alert";
import axios from "axios";
import { AmealioLoader } from "../../Loader/AmealioLoader";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import { TextField, FormControl, Select, MenuItem } from "@material-ui/core";
import { Image, Button, Col, Row, Form, Modal } from "react-bootstrap";
import InputNumberFunc from "../../../function/InputNumberFunc";
import {
  NewInputText,
  PasswordReusableInput,
} from "../inputReusableComponent/InputBoxComponent";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";
import { admin_reset_password_pending_active_rq } from "../../../store/actions/SuperAdminActions/adminPendingActiveDinersAction";
import { AdminResetPasswordValidation } from "../../../store/validation/allValidationFile/authenticationValidation/AdminResetPasswordValidation";

const strongRegex = new RegExp(
  /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,32}$/
);

export class ResetPasswordPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      view: false,
      viewConfirm: false,
      country_code: "",
      number: "",
      password: "",
      confirm_password: "",
      passwordIcon: true,
      slashEyeIcon: false,
      passwordIconTwo: true,
      slashEyeIconTwo: false,
      loading: false,
      errors: {},
    };
  }

  componentDidMount() {
    this.setState({ loading: true });
    axios
      .get("https://ipapi.co/json")
      .then((result) =>
        this.setState({
          country_code: result.data.country_calling_code,
          loading: false,
        })
      )
      .catch((error) =>
        this.setState({
          error,
          isLoading: false,
        })
      );
    this.props.clear_all_errors();
  }

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  handleOnChange = (value) => {
    this.setState({ country_code: "+" + value, errors: {} });
  };

  onChange = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    this.setState({
      [e.target.name]: number,
      errors: {},
    });
    this.props.clear_all_errors();
    // this.props.clear_all_errors();
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else if (
      e.target.name === "password" &&
      !strongRegex.test(e.target.value)
    ) {
      errors[
        e.target.name
      ] = `Passwords must contain at least six characters, including lowercase, uppercase, numbers and special characters.`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
    });
  };

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    let errors = this.state.errors;
    switch (name) {
      case "password":
        errors.password = strongRegex.test(value)
          ? ""
          : "Passwords must contain at least six characters, including lowercase, uppercase, numbers and special characters.";
        break;
      case "confirm_password":
        errors.confirm_password =
          value.length < 6
            ? "Confirm password must contain atleast 6 characters"
            : "";
        break;
      default:
        break;
    }
    this.setState({ errors, [name]: value });
  };

  handleClickShowPassword = (e) => {
    this.setState({
      view: !this.state.view,
    });
  };

  handleConfirmShowPassword = (e) => {
    this.setState({
      viewConfirm: !this.state.viewConfirm,
    });
  };

  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  handleMouseDownPasswordTwo = (event) => {
    event.preventDefault();
  };

  onPasswordChange = (e) => {
    this.setState({
      view: !this.state.view,
      passwordIcon: false,
      slashEyeIcon: true,
    });
  };

  onPasswordChangeTwo = (e) => {
    this.setState({
      viewConfirm: !this.state.viewConfirm,
      passwordIconTwo: false,
      slashEyeIconTwo: true,
    });
  };

  onPasswordHide = (e) => {
    this.setState({
      view: !this.state.view,
      passwordIcon: true,
      slashEyeIcon: false,
    });
  };

  onPasswordHideTwo = (e) => {
    this.setState({
      viewConfirm: !this.state.viewConfirm,
      passwordIconTwo: true,
      slashEyeIconTwo: false,
    });
  };

  resetPopupOpen = (e) => {
    this.setState({ openModal: true });
  };

  resetPopupClose = (e) => {
    this.setState({
      openModal: false,
      number: "",
      password: "",
      confirm_password: "",
    });
  };

  /******************************
   * @DESC - ON SUBMIT HANDLER
   *****************************/
  handleSubmit = (e) => {
    e.preventDefault();
    const { errors, isValid } = AdminResetPasswordValidation(this.state);
    if (!isValid) {
      this.setState({
        errors: errors,
      });
    } else {
      const token = this.props.auth.user.accessToken;
      const formData = {
        country_code: this.state.country_code,
        mobile_number: this.state.number,
        password: this.state.password,
        _id: this.props.data.vendor_id,
      };
      this.props.admin_reset_password_pending_active_rq(
        formData,
        token,
        this.onSuccessCallback,
        this.onErrorCallback
      );
    }
  };

  onSuccessCallback = () => {
    Alert.success(`<h4>Password Reset Successfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    this.resetPopupClose();
  };

  onErrorCallback = (data) => {
    Alert.error(
      `<h4>${
        data.response.data.code === 404 ? "You Enter Worng Mobile Number" : ""
      }</h4>`,
      {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      }
    );
  };

  render() {
    const { password, confirm_password, number, loading, errors } = this.state;
    return (
      <React.Fragment>
        <button
          className="enIconBtn mr-3 action_icon_padding bg-transparent"
          onClick={this.resetPopupOpen}
          type="button"
        >
          <Image
            src={require("../../../assets/images/Icon/reset.svg")}
            alt="Reset Password"
            title="Reset Password"
            fluid
          />
        </button>
        <Modal
          show={this.state.openModal}
          onHide={this.resetPopupClose}
          centered
        >
          <Modal.Header className="py-0 pt-2 border-0" closeButton>
            <Modal.Title> Reset Password</Modal.Title>
          </Modal.Header>
          <Modal.Body className="f16-500">
            <Form noValidate onSubmit={this.handleSubmit}>
              <Row>
                <Col xs={4} className="pr-0">
                  <Form.Group
                    className="reusableInputComponent-main mb-0"
                    controlId={"country_code"}
                  >
                    <div className="input-phone-country-code-reusable ">
                      <select
                        className="w-100"
                        name="country_code"
                        value={this.state.country_code}
                        onChange={this.onChange}
                      >
                        <option value={this.state.country_code}>
                          {this.state.country_code}
                        </option>
                        {getCountries().map(
                          (country) => (
                            // this.state.country_code !==
                            // "+" + getCountryCallingCode(country) && (
                            <option
                              key={country}
                              value={"+" + getCountryCallingCode(country)}
                            >
                              {en[country]} (+{getCountryCallingCode(country)})
                            </option>
                          )
                          // )
                        )}
                      </select>
                    </div>
                  </Form.Group>
                </Col>
                <Col xs={8}>
                  <Form.Group className="mb-0">
                    <NewInputText
                      extraClass="mb-0"
                      name="number"
                      inputType="number"
                      onFocusOut={this.onFocusOut}
                      onChange={this.onChange}
                      onKeyDown={InputNumberFunc}
                      value={this.state.number}
                      maxLength="10"
                      errorText={
                        this.state.number.length > 0 &&
                        this.state.number.length <= 9
                          ? "Enter valid Mobile Number"
                          : null || errors.number === "number is required"
                          ? "mobile number is required"
                          : null
                      }
                      errorTrue={
                        (this.state.number.length > 0 &&
                          this.state.number.length <= 9) ||
                        errors.number === "number is required"
                          ? true
                          : false
                      }
                      labelText="Phone Number"
                      controlClass={
                        (this.state.number.length > 0 &&
                          this.state.number.length <= 9) ||
                        errors.number === "number is required"
                          ? "outlined-error-helper-text"
                          : "outlined-helperText"
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>
              <div className="mt-2 mb-2">
                <PasswordReusableInput
                  onKeyPress={(event) => {
                    if (!/^\S*$/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  extraClass="mt-4 w-100"
                  labelText="Enter New Password"
                  inputTypeState={this.state.view}
                  value={this.state.password}
                  name="password"
                  onFocusOut={this.onFocusOut}
                  handleChange={this.handleChange}
                  handleClickShowPassword={this.handleClickShowPassword}
                  handleMouseDownPassword={this.handleMouseDownPassword}
                  errorText={errors.password}
                  errorTrue={
                    errors.password === "password is Required" ||
                    errors.password === "password is required" ||
                    errors.password ===
                      "Passwords must contain at least six characters, including lowercase, uppercase, numbers and special characters."
                      ? true
                      : false
                  }
                  wLabel={160}
                />
                <div className="f10-400 mt-1 opacity5">
                  Maximum 8+characters, 1 capital letter, Number
                </div>
              </div>
              <div className="mt-2 mb-2">
                <PasswordReusableInput
                  onKeyPress={(event) => {
                    if (!/^\S*$/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  extraClass="mt-4 w-100"
                  labelText="Confirm Password"
                  inputTypeState={this.state.viewConfirm}
                  value={this.state.confirm_password}
                  name="confirm_password"
                  onFocusOut={this.onFocusOut}
                  handleChange={this.handleChange}
                  handleClickShowPassword={this.handleConfirmShowPassword}
                  handleMouseDownPassword={this.handleMouseDownPasswordTwo}
                  errorText={
                    this.state.confirm_password.length === 0
                      ? errors.confirm_password
                      : "Password and Confirm Password do not match" &&
                        this.state.password !== this.state.confirm_password
                      ? "Password and Confirm Password do not match"
                      : ""
                  }
                  errorTrue={
                    this.state.confirm_password.length === 0
                      ? errors.confirm_password
                      : "Password and Confirm Password do not match" &&
                        this.state.password !== this.state.confirm_password
                  }
                  wLabel={140}
                />
                <div className="f10-400 mt-1 opacity5">
                  Maximum 8+characters, 1 capital letter, Number
                </div>
              </div>
              <div className="d-flex justify-content-start border-0 mt-3">
                <Button
                  variant="outline-secondary"
                  className="mr-3 f16_700_HelveticaNeue d-flex align-items-center justify-content-center"
                  style={{
                    width: "150px",
                    height: "48px",
                    borderRadius: "8px",
                    border: "2px solid #212121",
                  }}
                  onClick={this.resetPopupClose}
                >
                  No
                </Button>
                <Button
                  variant={
                    password === "" || confirm_password === "" || number === ""
                      ? "outline-secondary"
                      : "outline-danger"
                  }
                  className="f16_700_HelveticaNeue d-flex align-items-center justify-content-center"
                  style={{
                    width: "150px",
                    height: "48px",
                    borderRadius: "8px",
                    border:
                      password === "" ||
                      confirm_password === "" ||
                      number === ""
                        ? "2px solid #000000"
                        : "2px solid #EE3A23",
                    backgroundColor:
                      password === "" ||
                      confirm_password === "" ||
                      number === ""
                        ? "transparent"
                        : "#EE3A23",
                    color:
                      password === "" ||
                      confirm_password === "" ||
                      number === ""
                        ? "#000000"
                        : "#ffffff",
                  }}
                  type={
                    password === "" || confirm_password === "" || number === ""
                      ? "button"
                      : "submit"
                  }
                >
                  Yes
                </Button>
              </div>
            </Form>
          </Modal.Body>
          {/* <Modal.Footer className="justify-content-start border-0">
          </Modal.Footer> */}
        </Modal>
      </React.Fragment>
    );
  }
}

ResetPasswordPopup.propTypes = {
  admin_reset_password_pending_active_rq: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  admin_reset_password_pending_active_rq,
})(withRouter(ResetPasswordPopup));
